import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';

const ModuleLottieIcon = ({ animationData, className = '', size = 48 }) => {
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const updatePreference = () => setReducedMotion(mediaQuery.matches);

    updatePreference();
    mediaQuery.addEventListener('change', updatePreference);

    return () => mediaQuery.removeEventListener('change', updatePreference);
  }, []);

  return (
    <div
      className={`module-lottie-icon ${className}`.trim()}
      style={{ width: size, height: size }}
    >
      <Lottie
        animationData={animationData}
        loop={!reducedMotion}
        autoplay={!reducedMotion}
        aria-hidden="true"
      />
    </div>
  );
};

export default ModuleLottieIcon;
